{
  "title": "materials",
  "type": "object",
  "uniqueItems": true,
  "patternProperties" : {
  "^[a-z;/_]+$":  {
      "title": "material",
      "type": "object",
      "patternProperties": {
        "^[0-9]+$": { "type": "number" }
      },
      "additionalProperties": false
    }
  },
  "additionalProperties": false
}